import { Component, Input, ViewEncapsulation } from '@angular/core';

import { PreflightFinding, PreflightNumbers, PreflightResult, PreflightSeverity } from 'src/app/shared/document-preflight';
import {
  PREFLIGHT_CODE_TEXT, bomViaShort, preflightProductLabel, preflightSeverityLabel, preflightSeverityTag, preflightSummaryNumbers
} from 'src/app/shared/document-preflight-text';

/**
 * Compact list of the pre-flight findings that raise the "На печать" confirmation (IPF-5). It sits inside the existing
 * confirmation dialog (content projection), so there is one dialog, not two. Only findings with a severity are listed
 * ("cannot determine" says nothing), the most severe first as the API orders them, capped at `max` with a count of the rest.
 */
@Component({
  selector: 'app-document-preflight-summary',
  templateUrl: './document-preflight-summary.component.html',
  styleUrls: ['./document-preflight-summary.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class DocumentPreflightSummaryComponent {

  @Input() result: PreflightResult | null = null;
  @Input() max: number = 6;

  get flagged(): PreflightFinding[] { return this.result ? this.result.findings.filter(f => f.severity > 0) : []; }

  get shown(): PreflightFinding[] { return this.flagged.slice(0, this.max); }

  get hidden(): number { return Math.max(0, this.flagged.length - this.max); }

  codeText(f: PreflightFinding): string { return PREFLIGHT_CODE_TEXT[f.code] || f.code; }

  productLabel(f: PreflightFinding): string { return preflightProductLabel(f); }

  via(f: PreflightFinding): string { return bomViaShort(f.bom); }

  numbersText(n: PreflightNumbers): string { return preflightSummaryNumbers(n); }

  severityLabel(severity: PreflightSeverity): string { return preflightSeverityLabel(severity); }

  severityTag(severity: PreflightSeverity): 'danger' | 'warning' | 'secondary' { return preflightSeverityTag(severity); }
}
